export default {
    bindings: {
        item: '<',
        loading: '<',
        guests: '<'
    },
    controller: 'orderCreateTabsController',
    template: require('../views/order.create.tabs.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/orderCreation/components/order.create.tabs.component.js